export default __webpack_public_path__ + "static/media/Rubik-Medium.5bd2b2c6.ttf";